import type { ReactNode } from 'react';

interface Props {
  titulo: string;
  children?: ReactNode;
  textoConfirmar: string;
  textoCancelar?: string;
  /// 'peligro' pinta el botón de confirmar en coral, para acciones que descartan algo.
  tono?: 'normal' | 'peligro';
  onConfirmar: () => void;
  onCancelar: () => void;
}

/// Pop-up chico de confirmación que se apoya encima de cualquier otro modal.
/// El Escape lo maneja quien lo abre, para no cerrar también el modal de abajo.
export function DialogoConfirmacion({
  titulo,
  children,
  textoConfirmar,
  textoCancelar = 'Cancelar',
  tono = 'normal',
  onConfirmar,
  onCancelar,
}: Props) {
  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-[rgba(8,15,26,.6)] px-4"
      onClick={(evento) => {
        evento.stopPropagation();
        onCancelar();
      }}
      role="presentation"
    >
      <div
        className="w-full max-w-[400px] animate-aparecer rounded-2xl border border-white/[.12] bg-panel p-5 shadow-modal sm:p-6"
        onClick={(evento) => evento.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
        aria-label={titulo}
      >
        <h3 className="font-titulo text-[17px] font-extrabold">{titulo}</h3>
        {children && (
          <div className="mt-2 text-[13px] leading-relaxed text-tenue">{children}</div>
        )}

        <div className="mt-5 flex flex-wrap justify-end gap-2.5">
          <button
            type="button"
            onClick={onCancelar}
            className="rounded-[10px] border border-white/[.18] px-4 py-2 text-[13px] text-suave transition-colors hover:bg-white/5"
          >
            {textoCancelar}
          </button>
          <button
            type="button"
            autoFocus
            onClick={onConfirmar}
            className={`rounded-[10px] px-4 py-2 font-titulo text-[13px] font-bold text-tinta transition-colors ${
              tono === 'peligro' ? 'bg-coral hover:opacity-90' : 'bg-lima hover:bg-lima-claro'
            }`}
          >
            {textoConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}
